import { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import inviteStep from './assets/inviteStep.svg';
import bgPic from './assets/bgHead.png';

const Wrapper = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: url(${bgPic}) no-repeat top left/138px,
    linear-gradient(180deg, #dde9fe 0%, #f7f7f8 100%);
  [data-head] {
    line-height: 70px;
    margin-top: 14px;
    color: #1f34ae;
    font-size: 26px;
    font-weight: 600;
    text-indent: 50px;
    text-align: left;
  }
  [data-step] {
    display: block;
    margin: 0 auto;
  }
`;
const InviteWraper = ({
  children,
  ...others
}: { children: React.ReactNode } & HTMLAttributes<HTMLDivElement>) => {
  return (
    <Wrapper {...others}>
      <div data-head>ChatPlusAI，邀好友赚现金，仅需3步，大额红包等你拿！</div>
      <img data-step src={inviteStep} alt="" />
      {children}
    </Wrapper>
  );
};

export default InviteWraper;
